import * as optimizelySdk from '@optimizely/optimizely-sdk';
import { directoryStore } from '../stores/DirectoryStore';

const optimizely = optimizelySdk.createInstance({
  sdkKey: '3JPj8ZkpH1w5UzbVWoW9Q',
});

optimizely?.onReady().then(({ success, reason }) => {
  if (!success) {
    console.log(`OptimizelySdk client initialization unsuccessful, reason: ${reason}`);
    return;
  }
});

function showFeature(feature: string) {
  if (!optimizely) {
    console.log('OptimizelySdk not initialized');
    return false;
  }
  if (directoryStore.prismContext) {
    const attributes = {
      email: directoryStore.prismContext.originalUser.email,
      turnstileOrganizationId: directoryStore.prismContext.organization?.turnstileOrganizationId || null,
      organizationId: directoryStore.prismContext.account?.instanceId || null,
      trackerId: directoryStore.trackerId || null,
    };
    const user = optimizely.createUserContext(attributes.email, attributes);
    const decision = user?.decide(feature);
    return decision?.enabled;
  }
  return false;
}

export const showOcpContentRecsDestinations = () => {
  return showFeature('ocp_content_recs_destination');
};

export const showDataSyncMetricsUi = () => {
  return showFeature('feature_data_sync_metrics_ui');
};

export const showDataSyncMultiLanguage = () => {
  return showFeature('feature_data_sync_multi_language');
};
